import {makeAutoObservable, toJS, runInAction} from "mobx";

class ConfigStore {

    servers = null
    configs = []
    activeMode = 'easy'

    constructor() {
        makeAutoObservable(this);
        // Bind methods to this instance
        this.setServers = this.setServers.bind(this);
        this.setConfig = this.setConfig.bind(this);
        this.setActiveMode = this.setActiveMode.bind(this);
    }

    setServers(servers) {
        this.servers = servers;
    }

    setConfig(config) {
        this.configs = config;
    }

    updateConfigs(config) {
        runInAction(() => {
            if (!this.configs) {
                this.configs = [config];
            } else {
                this.configs.push(config);
            }
        });
    }

    setActiveMode(mode) {
        this.activeMode = mode;
    }


}

export default new ConfigStore();